import React, { PropsWithChildren, useContext } from "react";
import { MicroContentExcursionsFragment } from "types/graphql-types";

type ExcursionsMicroContentContextValue = MicroContentExcursionsFragment;

const ExcursionsMicroContentContex =
  React.createContext<ExcursionsMicroContentContextValue>({});

type Props = {
  content: MicroContentExcursionsFragment | undefined;
};

export const ExcursionsMicroContentProvider: React.FC<
  PropsWithChildren<Props>
> = ({ children, content = {} }) => {
  return (
    <ExcursionsMicroContentContex.Provider value={content}>
      {children}
    </ExcursionsMicroContentContex.Provider>
  );
};

export const useExcursionsMicroContent = () => {
  return useContext(ExcursionsMicroContentContex);
};
